import { FC } from "react";

import { ICustomField } from "@ryde/shared";

export const HiddenFieldTemplate: FC<ICustomField> = () => {
  return null;
};
// This component is intentionally left empty as it serves as a placeholder
// for hidden fields in forms. It does not render any UI elements.
